module.exports = __webpack_public_path__ + "img/pos--avatar.c1ba896e.svg";